var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPromocodeTag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#47CE72",
    d: "M2 3.752V9.22c0 .622.245 1.218.684 1.657l6.437 6.437a2.34 2.34 0 0 0 3.31 0l4.883-4.883a2.34 2.34 0 0 0 0-3.31l-6.437-6.437A2.342 2.342 0 0 0 9.22 2H3.756A1.75 1.75 0 0 0 2 3.752m4.096 1.17a1.17 1.17 0 1 1 0 2.341 1.17 1.17 0 0 1 0-2.34Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPromocodeTag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/promocode-tag.d7cae36270db48a1347385679c1a3c94.svg";